import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "../../../examples/Tables/DataTable";
import data from "../../dashboard/components/Projects/data";
import useApi from "../../../components/Utils/api";
import toast from "react-hot-toast";
import { DateRangePicker } from "rsuite";
import { afterToday } from "rsuite/cjs/DateRangePicker/disabledDateUtils";
import reportsLineChartData from "../../dashboard/data/reportsLineChartData";
import Papa from "papaparse";

function DeReplyFile() {
  const { DeReplyColumns } = data();
  const { predefinedRanges } = reportsLineChartData;
  const [summary, setSummary] = useState([]);
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);

  const api = useApi(); // Using the custom `useApi` hook for API calls

  useEffect(() => {
    fetchSettlementReport(dateRange);
  }, [dateRange]);

  const fetchSettlementReport = async (dateRange) => {
    try {
      const response = await api.get(
        `reports/dereply/list?startDate=${formatDate(dateRange[0])}&endDate=${formatDate(dateRange[1])}`
      );
      if (response.data.statusCodeValue === 200) {
        const modifiedData = response.data.body.map((item) => ({
          ...item,
          action: renderActions(item),
        }));
        setSummary(modifiedData);
      } else {
        const toastId = toast.error("No Record Found", { autoClose: false }); // Prevents auto-closing
        setTimeout(() => toast.dismiss(toastId), 1000); // Dismisses the toast after 1 second
        
        
      }
    } catch (error) {
      const errorMessage =
        error.response?.status === 403
          ? "You do not have permission to perform this action."
          : "No Record Found";
      toast.error(errorMessage);
    }
  };
// Format date to 'yyyy-MM-dd' in Australia/Sydney timezone
const formatDate = (date) => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'Australia/Sydney' };
  const formatter = new Intl.DateTimeFormat('en-AU', options);
  const parts = formatter.formatToParts(date);
  const year = parts.find(part => part.type === 'year').value;
  const month = parts.find(part => part.type === 'month').value;
  const day = parts.find(part => part.type === 'day').value;

  return `${year}-${month}-${day}`;
};


  const renderActions = (item) => (
    <MDBox display="flex" alignItems="center">
      <Icon fontSize="small" style={{ cursor: "pointer" }} onClick={() => handleDownload(item.id)}>
        download
      </Icon>
    </MDBox>
  );

  const handleDownload = (fileId) => {
    const downloadUrl = `${process.env.REACT_APP_BASE_URL}/api/adminPortal/v1/de-reply-file/download/${fileId}`;
    window.open(downloadUrl, "_blank");
  };

  const generateCSV = () => {
    if (summary.length === 0) return "";

    const headers = DeReplyColumns.filter((column) => column.Header !== "Action").map(
      (column) => column.Header
    );
    const summaryData = summary.map((item) =>
      DeReplyColumns.filter((column) => column.Header !== "Action").map(
        (column) => item[column.accessor]
      )
    );

    return Papa.unparse([headers, ...summaryData], { quotes: true });
  };

  const handleDownloadCSV = () => {
    if (summary.length === 0) {
      const toastId = toast.error("No records found to download", { autoClose: false }); // Prevents auto-closing
      setTimeout(() => toast.dismiss(toastId), 1000); // Dismisses the toast after 1 second
      
      return;
    }
    const blob = new Blob([generateCSV()], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `DeReplyColumns${new Date().toISOString().slice(0, 19).replace(/:/g, "-")}.csv`;
    link.click();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          {/* Centering DateRangePicker */}
          <Grid item xs={12} display="flex" justifyContent="center">
            <DateRangePicker
              name="date-range"
              disabledDate={afterToday()}
              ranges={predefinedRanges}
              onChange={(range) => setDateRange(range)}
              format="yyyy-MM-dd"
              value={dateRange}
            />
          </Grid>
          <Grid item xs={12} display="flex" justifyContent="flex-start">
            <MDButton
              variant="gradient"
              onClick={handleDownloadCSV}
              color="info"
              style={{ marginLeft: "0px", marginBottom: "12px" }}
            >
              Export
            </MDButton>
          </Grid>
          {/* DataTable Section */}
          <Grid item xs={12}>
            <DataTable
              table={{ columns: DeReplyColumns, rows: summary }}
              showTotalEntries
              isSorted
              noEndBorder
              entriesPerPage
              canSearch
            />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DeReplyFile;
